// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z02I","comment":"styles_comment__3P7s1"};